import { Injectable, signal } from '@angular/core';
import { Subject, Observable } from 'rxjs';
import { JustificationModalConfig } from './justification-modal.model';

@Injectable({
    providedIn: 'root',
})
export class JustificationModalService {
    readonly showModal = signal<boolean>(false);
    readonly modalConfig = signal<JustificationModalConfig | null>(null);

    private responseSubject!: Subject<string | false>;

    /**
     * Opens the justification modal.
     * Returns Observable that emits the reason text or false if cancelled.
     */
    open(config: JustificationModalConfig): Observable<string | false> {
        this.modalConfig.set(config);
        this.showModal.set(true);
        this.responseSubject = new Subject<string | false>();
        return this.responseSubject.asObservable();
    }

    confirm(reason: string): void {
        this.showModal.set(false);
        this.responseSubject.next(reason);
        this.responseSubject.complete();
    }

    cancel(): void {
        this.showModal.set(false);
        this.responseSubject.next(false);
        this.responseSubject.complete();
    }
}
